import { LOCAL_STORAGE_KEYS, useLocalStorage } from "@portal/app/_components/hooks/useLocalStorage";
import { useCallback } from "react";

export function useSignUpAnalytics(): () => {
  affiliateSlug?: string;
  affiliateExternalId?: string;
  affiliateFirstEncounteredAt?: string;
} {
  const [affiliateSlug] = useLocalStorage<string>(LOCAL_STORAGE_KEYS.AFFILIATE_SLUG);
  const [affiliateExternalId] = useLocalStorage<string>(LOCAL_STORAGE_KEYS.AFFILIATE_EXTERNAL_ID);
  const [affiliateFirstEncounteredAt] = useLocalStorage<string>(
    LOCAL_STORAGE_KEYS.AFFILIATE_FIRST_ENCOUNTERED_AT
  );
  return useCallback(() => {
    return {
      affiliateSlug,
      affiliateExternalId,
      affiliateFirstEncounteredAt,
    };
  }, [affiliateExternalId, affiliateFirstEncounteredAt, affiliateSlug]);
}
